import React, { useState } from "react";
import { Lock } from "lucide-react";

interface PasswordPromptProps {
  fileName: string;
  incorrect: boolean;
  onSubmit: (password: string) => void;
  onCancel: () => void;
}

/** Modal asking for the password to an encrypted PDF. */
const PasswordPrompt: React.FC<PasswordPromptProps> = ({
  fileName,
  incorrect,
  onSubmit,
  onCancel,
}) => {
  const [password, setPassword] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password) onSubmit(password);
  };

  return (
    <div className="password-prompt-overlay">
      <form className="password-prompt" onSubmit={submit}>
        <Lock size={22} className="password-prompt-icon" />
        <h2 className="password-prompt-title">Password required</h2>
        <p className="password-prompt-sub" title={fileName}>
          "{fileName}" is password protected.
        </p>
        {incorrect && (
          <p className="password-prompt-error">
            Incorrect password. Try again.
          </p>
        )}
        <input
          type="password"
          autoFocus
          className="password-prompt-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
        />
        <div className="password-prompt-actions">
          <button type="button" className="tool-action" onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className="tool-primary" disabled={!password}>
            Unlock
          </button>
        </div>
      </form>
    </div>
  );
};

export default PasswordPrompt;
